import { ConnectionLines, ConnectionLineTypes, UpdateFacetOnModelMessage, StartLineConnectionAction, EndLineConnectionAction, SetDefaultLineColorAction } from "flavr-common";
import { InteractionHandler } from "../Interactions";
const DEFAULT_LINE_COLOR = 0xff0000;
export class LineConnectionInteractionHandler extends InteractionHandler {
    constructor() {
        super("LineConnectionInteractionHandler", [], [StartLineConnectionAction.typestatic, EndLineConnectionAction.typestatic, SetDefaultLineColorAction.typestatic], []);
        this.models = {};
        this.color = DEFAULT_LINE_COLOR;
        this.connection.subscribe([`${UpdateFacetOnModelMessage.typestatic}(${ConnectionLines.typestatic})`], (msg) => {
            if (UpdateFacetOnModelMessage.is(msg)) {
                if (ConnectionLines.is(msg.facet)) {
                    const model = this.models[msg.uid];
                    model && (model.connections = new ConnectionLines(msg.facet.connections));
                }
            }
        });
    }
    performAction(params, context) {
        if (StartLineConnectionAction.is(params)) {
            if (context.targetUid) {
                this.pendingConnection = {
                    startUid: context.targetUid,
                    color: params.color || this.color,
                    lineThickness: 0.02,
                    arrowHeadWidth: 0.06,
                    arrowHeadLength: 0.1
                };
            }
        }
        else if (SetDefaultLineColorAction.is(params)) {
            this.color = params.color;
        }
        else if (EndLineConnectionAction.is(params)) {
            const targetUid = context.targetUid;
            if (this.pendingConnection && targetUid && this.pendingConnection.startUid !== targetUid) {
                const id = `custom`;
                let wasDeleted = false;
                let startModel = this.models[this.pendingConnection.startUid];
                let connectionsToTargetModel = startModel ? startModel.connections.connections[targetUid] : undefined;
                if (startModel) {
                    if (connectionsToTargetModel && connectionsToTargetModel[id]) {
                        delete connectionsToTargetModel[id];
                        wasDeleted = true;
                    }
                }
                else {
                    startModel = this.models[this.pendingConnection.startUid] = {
                        connections: new ConnectionLines({})
                    };
                }
                if (!wasDeleted) {
                    if (!connectionsToTargetModel) {
                        connectionsToTargetModel = startModel.connections.connections[targetUid] = {};
                    }
                    connectionsToTargetModel[id] = {
                        type: ConnectionLineTypes.Arrow,
                        lineColor: this.pendingConnection.color,
                        lineThickness: this.pendingConnection.lineThickness,
                        arrowHeadWidth: this.pendingConnection.arrowHeadWidth,
                        arrowHeadLength: this.pendingConnection.arrowHeadLength
                    };
                }
                this.connection.send(new UpdateFacetOnModelMessage(this.pendingConnection.startUid, startModel.connections));
            }
            this.pendingConnection = undefined;
        }
    }
}
